export type McpToolAccess = "read";
export type McpToolExecution = "server" | "client";

export interface McpToolDescriptor {
  name: string;
  description: string;
  access: McpToolAccess;
  execution?: McpToolExecution;
  input_schema: Record<string, unknown>;
}

export interface McpToolCatalogResponse {
  tools: McpToolDescriptor[];
  total: number;
}

export interface McpToolInvokeRequest {
  tool_name: string;
  arguments?: Record<string, unknown>;
}

export interface McpToolInvokeResponse<T = unknown> {
  tool_name: string;
  access: McpToolAccess;
  result: T;
}

/** Контракт камеры от tool zoom_to_features. */
export interface McpMapCameraResult {
  type: "map_camera";
  bounds: [number, number, number, number];
  padding: number;
  max_zoom: number;
  feature_count: number;
}

export function isMcpMapCameraResult(value: unknown): value is McpMapCameraResult {
  if (!value || typeof value !== "object") return false;
  const v = value as Record<string, unknown>;
  return (
    v.type === "map_camera" &&
    Array.isArray(v.bounds) &&
    v.bounds.length === 4 &&
    v.bounds.every((n) => typeof n === "number")
  );
}
